import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { StringHelper } from '../helpers/strings.helper';
import { DeviceService } from './device.service';
import { LocalStorageService } from './local-storage.service';
import { SavedUserTokenData } from '../models';

@Injectable({
	providedIn: 'root',
})
export class MixPanelService {
	private readonly PROJECT_TOKEN = '35c1d49ae2032b92578e334d89615266';
	private identified = false;

	constructor(private deviceService: DeviceService, private localStorageService: LocalStorageService) {
		mixpanel.init(this.PROJECT_TOKEN);
	}

	track(eventName: string, action: any): void {
		if (!StringHelper.isNullOrEmpty(action)) {
			try {
				this.maybeIdentify();
				mixpanel.track(eventName, action);
			} catch (error) {
				console.log('Error from MixPanel');
			}
		}
	}

	reset() {
		mixpanel.reset();
		this.identified = false;
	}

	private maybeIdentify() {
		if (this.identified) return;

		const userData = this.localStorageService.getSaveTokenData() as SavedUserTokenData;

		mixpanel.identify(userData?.username ?? mixpanel.get_distinct_id());

		if (userData) {
			mixpanel.people.set({
				'$name': `${userData.firstName} ${userData.lastName}`,
				'$first_name': userData.firstName,
				'$last_name': userData.lastName,
				'$email': userData.email,
				'$phone' : userData.phone,
			});

			this.identified = true;
		}
	}
}
